import request from "@/modules/huyu-framework/backend/utils/request";

// 登录方法
export function login(username, password, code, uuid, keyId) {
  const data = {
    username,
    password,
    code,
    uuid,
    keyId,
  };
  return request({
    url: "/login",
    headers: {
      isToken: false,
      repeatSubmit: false,
    },
    method: "post",
    data: data,
  });
}

// 注册方法
export function register(data) {
  return request({
    url: "/register",
    headers: {
      isToken: false,
    },
    method: "post",
    data: data,
  });
}

// 获取用户详细信息
export function getInfo() {
  let url = "/getInfo";

  let getInfoShow = localStorage.getItem("getInfoShow");

  if (getInfoShow && getInfoShow === "true") {
  
    url = "/getInfo?projectId=" + localStorage.getItem("loginId");
  }

  localStorage.setItem("getInfoShow", false);

  return request({
    url: url,
    method: "get",
  });
}

// 退出方法
export function logout() {
  return request({
    url: "/logout",
    method: "post",
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: "/captchaImage",
    headers: {
      isToken: false,
    },
    method: "get",
    timeout: 20000,
  });
}
// 获取用户详细信息
export function getProjectList(id) {
  return request({
    url: "/project/projectList/" + id,
    method: "get",
  });
}
